import Guid from "common/values/guid/guid";
import EntityName from "legal-entities/values/entity-name/entity-name";

/** Entity member user information */

export interface UserEntityInfoJSON {
  entityId: string;
  entityName: string;
  isAdmin: boolean;
  isManager: boolean;
  isOfficer: boolean;
  entityVendorFlag?: boolean;
  entityClientFlag?: boolean;
}

export default class UserEntityInfo {
  public readonly entityId: Guid;
  public readonly entityName: EntityName;
  public readonly isAdmin: boolean;
  public readonly isManager: boolean;
  public readonly isOfficer: boolean;
  public readonly entityVendorFlag?: boolean;
  public readonly entityClientFlag?: boolean;

  /** Returns the entity id. */
  public get id(): Guid {
    return this.entityId;
  }

  constructor(
    entityId: Guid,
    entityName: EntityName,
    isAdmin: boolean,
    isManager: boolean,
    isOfficer: boolean,
    entityVendorFlag?: boolean,
    entityClientFlag?: boolean
  ) {
    this.entityId = entityId;
    this.entityName = entityName;
    this.isAdmin = isAdmin;
    this.isManager = isManager;
    this.isOfficer = isOfficer;
    this.entityVendorFlag = entityVendorFlag;
    this.entityClientFlag = entityClientFlag;
  }

  public static fromJSON(json: UserEntityInfoJSON): UserEntityInfo {
    if (!json.entityId || !json.entityName) {
      throw new InvalidUserEntityInfoError(json);
    }
    const id = Guid.fromJSON(json.entityId);
    if (!id) { throw new InvalidUserEntityInfoError(json); }
    return new UserEntityInfo(
      id,
      EntityName.fromJSON(json.entityName),
      json.isAdmin,
      json.isManager,
      json.isOfficer,
      json.entityVendorFlag,
      json.entityClientFlag
    );
  }
  public toJSON(): UserEntityInfoJSON {
    return {
      entityId: this.entityId.toJSON(),
      entityName: this.entityName.toJSON(),
      isAdmin: this.isAdmin,
      isManager: this.isManager,
      isOfficer: this.isOfficer,
      entityVendorFlag: this.entityVendorFlag,
      entityClientFlag: this.entityClientFlag
    };
  }
}

export class InvalidUserEntityInfoError extends Error {
  issues: unknown;

  constructor(issues: unknown) {
    super(`Invalid user entity info.`);
    this.issues = issues;
  }
}
